import React, { useState, useEffect, useRef } from 'react';
/** lib **/
import { Link } from 'react-router-dom';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';

import { client } from 'api/microcms';
/** components **/
import { ContentsTitle } from '../molecules';
import { FadeUp } from 'components/organisms';
import InfoImage from 'assets/images/info.png';
import NoticeNewsSp from 'assets/images/notice-news-sp.png';

import Pwan from 'assets/images/pwan.png';
/** styles,images **/
import s from '../../styles/organisms/news.module.scss';
import classNames from 'classnames';
import dayjs from 'dayjs';

export const TopNews: React.FC = () => {
  const [news, setNews] = useState([]);

  const inViewRef1 = useRef<HTMLHeadingElement>(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const animationEl = [inViewRef1];


  useEffect(() => {
    client
      .get({
        endpoint: "news",
      })
      .then((res) => {
        setNews(res.contents)
      })
      .catch((err) => console.log(err));
  }, []);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(s.inview);
          } else {
            entry.target.classList.remove(s.inview);
          }
        });
      },
      {
        root: null,
        rootMargin: '-10% 0px -0% 0px',
        threshold: 0,
      },
    );
    animationEl.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      animationEl.forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, [animationEl]);

  return (
    <div className={s.topNewsWrapper}>
      <FadeUp delay={0}>
        <div className={s.newsContents}>
          <div className={s.newsContentsInner}>
            <div className={s.contentsTitleWrapper}>
              <ContentsTitle className={s.contentsTitle} title="お知らせ" subTitle={`P-manからのお知らせや\nペットフレンドリー物件情報`} />
              <Link className={classNames(s.moreLink, s.pcOnly)} to="/news-list">
                <p>もっとみる</p>
                <GreenCircleArrow className={s.moreLinkIcon} />
              </Link>
            </div>
            <div className={s.contentsRow}>

              <ul className={s.newsList}>
                {news.map((newsItem: any) => (
                  <li key={newsItem.id}>
                    {newsItem.link ?
                      // 内部リンクがある場合
                      <Link to={newsItem.link}>
                        <div className={s.text}>
                          <div className={s.date}>
                            <p>{dayjs(newsItem.publishAt).format("YYYY/MM/DD")}</p>
                            <span className={s.tag}>
                              {newsItem.tag[0]}
                            </span>
                          </div>
                          <div className={s.title}>{newsItem.title}</div>
                        </div>
                      </Link>
                      :
                      newsItem.external_link ?
                        // 外部リンクがある場合
                        <a href={newsItem.external_link} target="_blank" rel="noreferrer">
                          <div className={s.text}>
                            <div className={s.date}>
                              <p>{dayjs(newsItem.publishAt).format("YYYY/MM/DD")}</p>
                              <span className={s.tag}>
                                {newsItem.tag[0]}
                              </span>
                            </div>

                            <div className={s.title}>{newsItem.title}</div>
                          </div>
                        </a> : newsItem.contents ?
                          // ニュース本文がある場合
                          <Link to={`/news?id=${newsItem.id}`}>
                            <div className={s.text}>
                              <div className={s.date}>
                                <p>{dayjs(newsItem.publishAt).format("YYYY/MM/DD")}</p>
                                <span className={s.tag}>
                                  {newsItem.tag[0]}
                                </span>
                              </div>
                              <div className={s.title}>{newsItem.title}</div>
                            </div>
                          </Link> :
                          // タイトルのみ
                          <div className={s.text}>
                            <div className={s.date}>
                              <p>{dayjs(newsItem.publishAt).format("YYYY/MM/DD")}</p>
                              <span className={s.tag}>
                                {newsItem.tag[0]}
                              </span>
                            </div>
                            <div className={s.title}>{newsItem.title}</div>
                          </div>}
                  </li>
                ))}
              </ul>
              <Link className={classNames(s.moreLink, s.spOnly)} to="/news">
                <p>もっとみる</p>
                <GreenCircleArrow className={s.moreLinkIcon} />
              </Link>
              <div className={s.info}>

                <div className={classNames(s.noticeImg, s.spOnly)}>
                  <img src={NoticeNewsSp} alt="ちょこちょこ更新してるよ！" />
                </div>
                <div className={s.spOnly}>
                  <div className={s.tag}>おすすめ物件INFO</div>
                </div>
                <div className={classNames(s.tag, s.pcOnly)}>おすすめ物件INFO</div>
                <a href='https://www.mecsumai.com/tphb-miyakojima-terrace/' target='_blank' rel="noreferrer" >
                  <img src={InfoImage} alt="猫ちゃんフレンドリー物件「都島テラス」募集スタート！！" />
                </a>
                <p>猫ちゃんフレンドリー物件「都島テラス」募集スタート！！</p>

                <div className={classNames(s.notice, s.pcOnly)} ref={inViewRef1}>
                  <p>ちょこちょこ更新してるよ！</p>
                  <img src={Pwan} alt="ピーワン" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </FadeUp>

      {/* <ParallaxItem className={s.parallaxBg}>
        <img src={BgLogo} alt={SERVICE_NAME} width={381} height={500} />
      </ParallaxItem> */}
    </div>
  );
};
